module.exports = __webpack_public_path__ + "assets/img/33_4_big.21cf28be.jpg";